import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '../shared.service';
import { ProjectType } from 'src/app/core/models/ProjectType';
import { UIControlTyp } from 'src/app/core/models/UIControlTyp';

@Component({
  standalone: false,
  selector: 'fdb-project-type',
  templateUrl: './project-type.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./project-type.component.scss']
})
export class ProjectTypeComponent implements OnInit {
  public UIControlTyp = UIControlTyp;
  public SelectedProjectTypeId: number = 0;
  /** Hiermit können Sie den UIControlTyp entscheiden => Default DropDownList */
  @Input() uiController: UIControlTyp = UIControlTyp.DropDownList;
  // tslint:disable-next-line: no-input-rename
  @Input('values')
  get values() {
    const val = this.uiController === UIControlTyp.MultiSelectList ?
      this.ProjectTypes.map(unit => Number(unit.id)) :
      Number(this.SelectedProjectTypeId || 0);
    return val;
  }
  set values(val: string | number | (string | number)[]) {
    if (Array.isArray(val)) {
      this.ProjectTypes = (val as (string | number)[]).map(id => this.getObjectFromList(Number(id)));
      this.getRefreshSelectedValue();
    } else {
      this.SelectedProjectTypeId = this.normalizeId(val as string | number);
      this.ProjectType = this.getObjectFromList(this.SelectedProjectTypeId);
    }
  }
  @Output() valuesChange = new EventEmitter();

  /** Enthält die ausgewählten Werte bei UIControlTyp.MultiSelectList */
  public ProjectTypes: ProjectType[] = [];
  /** Enthält die ausgewählten Wert bei UIControlTyp.DropDownList */
  public ProjectType: ProjectType;
  /** Enthält die Werte die angezeigt werden dürfen */
  public ProjectTypeList: ProjectType[] = [];
  /** Enthält die Originalliste mit allen Werten */
  private OriginalValues: ProjectType[] = [];

  constructor(private modulService: SharedService, private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.initProjectTypes();
  }

  initProjectTypes() {
    this.modulService.getProjectType()
      .subscribe(apiResult => {
        if (!apiResult.isSuccessful) {
          this.modulService.showNotification(apiResult.message, 'error');
        }
        if (apiResult.payload) {
          this.OriginalValues = apiResult.payload;
          this.ProjectTypeList = this.OriginalValues.filter(s => s.isActive === true);
          if (this.uiController === UIControlTyp.DropDownList) {
            this.ProjectTypeList.unshift(new ProjectType().getEmptyModel());
          }
          this.refreshSelectedValue();
          this.rebindSelectedProjectTypeId();
        }
      },
        err => this.modulService.showNotification(err, 'error'));
  }
  filterenbwunit(value: string) {
    this.ProjectTypeList = this.OriginalValues
      .filter((s) => (s.name || '').toLowerCase().indexOf(value.toLowerCase()) !== -1 && s.isActive === true);
  }

  valueChanged(event?: number | (string | number)[]): void {
    if (this.uiController === UIControlTyp.MultiSelectList) {
      if (Array.isArray(event)) {
        this.ProjectTypes = event.map(id => this.getObjectFromList(Number(id)));
      }
      this.getRefreshSelectedValue();
    } else {
      this.SelectedProjectTypeId = this.normalizeId(event as number);
      this.ProjectType = this.getObjectFromList(this.SelectedProjectTypeId);
    }

    this.valuesChange.emit(this.values);
  }

  getObjectFromList(id: number): ProjectType {
    if (id === 0) { return new ProjectType().getEmptyModel(); }
    const find = this.OriginalValues.find(unit => unit.id === id);
    return find ? find : new ProjectType().setId(id);
  }
  getName() {
    const find = this.getObjectFromList(Number(this.ProjectType ? this.ProjectType.id : 0));
    return find ? find.name : '';
  }
  getRefreshSelectedValue() {
    this.ProjectTypes = this.ProjectTypes
      .map(x => this.OriginalValues.find(y => Number(y.id) === Number(x.id)) || x)
      .filter(x => !!x);
  }

  private refreshSelectedValue() {
    if (this.uiController === UIControlTyp.MultiSelectList) {
      this.getRefreshSelectedValue();
      return;
    }

    this.ProjectType = this.getObjectFromList(Number(this.ProjectType ? this.ProjectType.id : this.SelectedProjectTypeId));
    this.SelectedProjectTypeId = Number(this.ProjectType ? this.ProjectType.id : 0);
  }

  private rebindSelectedProjectTypeId() {
    const selectedId = Number(this.SelectedProjectTypeId || 0);
    this.SelectedProjectTypeId = 0;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.SelectedProjectTypeId = selectedId;
      this.cdRef.detectChanges();
    });
  }

  private normalizeId(id: string | number): number {
    const parsed = Number(id);
    return isNaN(parsed) ? 0 : parsed;
  }
}
